// Given an x and y, it will return the magnitude and angle in radians.
const coordinatesToRadianAndMagnitude = ({ x, y, fromDirection = true }: { x: number; y: number; fromDirection?: boolean }) => {
    const magnitude = Math.sqrt(y * y + x * x);
    /**
     * Definition of atan is: Math.atan2(y: number, x: number): number, but this would calculate radians from X axis (east<->west).
     * In meteorology 0° is north, we have to swap 'y' and '
     */
    const radians = Math.atan2(x, y) + (fromDirection ? Math.PI : 0);

    return { magnitude, radians };
};

export { coordinatesToRadianAndMagnitude };
